// extracted by mini-css-extract-plugin
export default {"foundation":"Why_foundation__f5EIP","container":"Why_container__gIqau"};